import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import SignupStepper from '../../components/public/signup/SignupStepper.component';
import { PUBLIC_AUTHENTICATION_APP_PATHS } from '../../constants/authentication-paths.constants';
import { PUBLIC_PANELS } from '../../../shared/public/constants/panel.constants';
import { BASE_PUBLIC_V2_PATH } from '../../../shared/public/constants/path.constants';

const PANEL_ROUTES: Record<string, string> = {
  [PUBLIC_PANELS.LOGIN]: PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN,
};

const useStyles = makeStyles((theme) => ({
  wrapper: { display: 'flex', justifyContent: 'center', padding: theme.spacing(6, 3) },
  column: { width: '100%', maxWidth: 440 },
  title: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: theme.palette.client.primary.extraDark,
  },
}));

const SignupView: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const onSuccess = () => history.push(BASE_PUBLIC_V2_PATH);
  const onNavigate = (panel: string) => history.push(PANEL_ROUTES[panel] ?? PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN);

  return (
    <React.Fragment>
      <Helmet>
        <title>Créer un compte - Bio Culture</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={classes.wrapper}>
        <div className={classes.column}>
          <Typography variant="h4" component="h1" className={classes.title}>
            Créer un compte
          </Typography>

          <SignupStepper onSuccess={onSuccess} onNavigate={onNavigate} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignupView;
